import { render } from "./ImplantServices.vue?vue&type=template&id=c7721182"
import script from "./ImplantServices.vue?vue&type=script&lang=js"
export * from "./ImplantServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__